<template>
  <section class="section" :id="`uuid-${model.uuid}`">

    <div class="section__container">

      <div class="introduction__date" v-if="model.showDate">
        {{model.date}}
      </div>

      <div v-html="model.text" class="introduction__text"></div>

      <div class="introduction__social-sharing" v-if="model.socialShare && model.socialShare.length > 0">
        <social-sharing v-for="icon in model.socialShare"
                        :key="icon.uuid"
                        :url="common.actpageFullUrl"
                        :title="common.actpageMetaTitleLocalized"
                        :description="model.text | strippedContent"
                        inline-template
                        @open="sendAnalytics($event)"
        >
          <i :class="`icon-${icon.socialIcon}`">
            <span class="hide">{{ icon.socialLabel | capitalize({ onlyFirstLetter: true }) }}</span>
          </i>
        </social-sharing>
      </div>
    </div>
  </section>
</template>
<script>
  import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
    name: 'Introduction',

    props: {
      socialShare: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      sendAnalytics(network) {
        this.$analytics.pushEvent('share', `share_${network}`, this.common.actpageFullUrl);
      }
    }
  }
</script>